// @flow
// TODO: refactor with partners TableRow eventually
import React, { Component } from 'react';
//types
import {
  type Currencies,
  // type Currency,
  type TooltipProps,
  type ProcessingSum
} from '../../../../utilities/types';
import styled, { css } from 'styled-components';
import { ModelListTd } from '../../../../components/ModelListStyles';
import TableRowPartial from '../../../../modules/CrudTable/components/TableRowPartial';
import IconWithText from '../../../../components/IconWithText';
import { DefaultIcon } from '../../../../components/Icon';
import { Default, Mobile } from '../../../../components/Responsive';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { TextStyleP } from '../../../../components/TextStyles';

type Props = {
  index: number,
  tableTotal: number,
  totalProcessingVolUsd: number,
  totalFeesUsd: number,
  // partnerCurrency: Currency,
  currencies: Currencies,
  processing_sum: ProcessingSum,
  ...$Exact<TooltipProps>,
  totalProcessingVolUsd: string,
  totalFeesUsd: string
};

const CustomModelListTd = styled(ModelListTd)`
  text-transform: uppercase;
  && {
    border-bottom: 0;
  }
  ${props =>
    props.bold &&
    css`
      font-weight: 500;
      ${props => props.theme.fontStackHeader};
      > div {
        > p {
          font-weight: 500;
          ${props => props.theme.fontStackHeader};
        }
      }
    `}
`;

export default class TableRow extends Component<Props> {
  render() {
    const { processing_sum, tableTotal } = this.props;
    const currency = this.props.currencies[processing_sum.currency];
    const lastRow = this.props.index === tableTotal - 1;

    return (
      <>
        <TableRowPartial
          id={this.props.index}
          options={{
            col1: (
              <ModelListTd>
                <DefaultIcon
                  name={currency.iso4217.toLowerCase()}
                  color={currency.color}
                />
                {processing_sum.currency}
              </ModelListTd>
            ),
            col2: (
              <>
                <Default>
                  <ModelListTd right>
                    {formatCurrency(
                      processing_sum.transaction_amount,
                      currency
                    )}
                  </ModelListTd>
                </Default>
                <Mobile>
                  <ModelListTd>
                    {formatCurrency(
                      processing_sum.transaction_amount,
                      currency
                    )}
                    <Mobile>
                      <TextStyleP color="dustierGray">
                        Fees:{' '}
                        {formatCurrency(
                          processing_sum.transaction_fee,
                          currency
                        )}
                      </TextStyleP>
                    </Mobile>
                  </ModelListTd>
                </Mobile>
              </>
            ),
            col3: (
              <ModelListTd right>
                {formatCurrency(processing_sum.transaction_fee, currency)}
              </ModelListTd>
            ),
            col4: (
              <ModelListTd right>
                {formatCurrency(processing_sum.revenue_share, currency)}
              </ModelListTd>
            )
          }}
        />

        {lastRow && (
          <TableRowPartial
            id={lastRow + 1}
            options={{
              col1: (
                <CustomModelListTd bold>
                  <IconWithText
                    message={
                      'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
                    }
                    label={'total'}
                    activeTooltip={this.props.activeTooltip}
                    tooltipName={'partners/show/TOTAL_TOOLTIP'}
                    showTooltip={this.props.showTooltip}
                    smallIcon
                    iconRight
                  />
                </CustomModelListTd>
              ),
              col2: (
                <>
                  <Default>
                    <CustomModelListTd bold right>
                      {formatCurrency(
                        this.props.totalProcessingVolUsd,
                        this.props.currencies['USD']
                      )}
                    </CustomModelListTd>
                  </Default>
                  <Mobile>
                    <CustomModelListTd bold>
                      {formatCurrency(
                        this.props.totalProcessingVolUsd,
                        this.props.currencies['USD']
                      )}
                    </CustomModelListTd>
                  </Mobile>
                </>
              ),
              col3: (
                <CustomModelListTd bold right>
                  {formatCurrency(
                    this.props.totalFeesUsd,
                    this.props.currencies['USD']
                  )}
                </CustomModelListTd>
              ),
              col4: (
                <CustomModelListTd bold right>
                  ---
                </CustomModelListTd>
              )
            }}
          />
        )}
      </>
    );
  }
}
